import { render, staticRenderFns } from "./simuladores.vue?vue&type=template&id=758bca1d"
import script from "./simuladores.vue?vue&type=script&lang=js"
export * from "./simuladores.vue?vue&type=script&lang=js"
import style0 from "./simuladores.vue?vue&type=style&index=0&id=758bca1d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports